import { ConfigApi, IdentityApi } from '@backstage/core-plugin-api';
import { PdpLoggerApi } from './pdp-logger-api';

export class PdpLoggerClient implements PdpLoggerApi {
  private readonly configApi: ConfigApi;
  private readonly identityApi: IdentityApi;

  constructor(options: { configApi: ConfigApi; identityApi: IdentityApi }) {
    this.configApi = options.configApi;
    this.identityApi = options.identityApi;
  }

  async log(
    level: 'info' | 'warn' | 'error',
    message: string,
    meta?: Record<string, any>,
  ) {
    const { token } = await this.identityApi.getCredentials();

    const backendUrl = this.configApi.getString('backend.baseUrl');
    const url = `${backendUrl}/api/pdp-logger-backend/log`;

    await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ level, message, meta }),
      credentials: 'include',
    });
  }
}
